import { useActiveOrganization } from '@repo/api-client/react';
import { Page, PageHeader } from '@/features/common/PageHeader';
import { Alert } from '@/components/ui/alert';
import { TeamManagementPanel } from '@/features/team/TeamManagementPanel';

/**
 * Team management for the *active* business. The per-business team
 * tab in `/settings/businesses/:id` is the canonical surface, but
 * this screen exists so the sidebar's "Team" link is meaningful for
 * users who only ever have one business.
 */
export function TeamSettingsScreen() {
  const org = useActiveOrganization();

  if (!org) {
    return (
      <Page>
        <PageHeader title="Team" />
        <Alert variant="danger">No active business selected.</Alert>
      </Page>
    );
  }

  return (
    <Page>
      <PageHeader
        title="Team"
        description={`Members and pending invites for ${org.nickname || org.name}.`}
      />
      <TeamManagementPanel orgId={org.id} orgName={org.nickname || org.name} />
    </Page>
  );
}
